import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { resetErrorMessage } from '../actions/internal';
import { toast } from 'react-toastify';

const convertToToastType = (messageType) => {
  if (messageType === 'alert') {
    return 'error';
  }

  if (messageType === 'success') {
    return 'success';
  }

  if (messageType === 'warning') {
    return 'warning';
  }

  return 'info';
}

const Error = ({ message, messageType, resetErrorMessage }) => {
  useEffect(() => {
    toast(message, {
      type: convertToToastType(messageType),
      onClose: () => {
        resetErrorMessage && resetErrorMessage();
      },
    });
  }, [message, messageType, resetErrorMessage]);

  return null;
};

const mapStateToProps = (state, ownProps) => ({
  message: ownProps.message || state.errorMessage.message,
  messageType: ownProps.messageType || state.errorMessage.messageType,
  status: state.errorMessage.status,
});

Error.propTypes = {
  message: PropTypes.string,
  messageType: PropTypes.string,
  status: PropTypes.bool.isRequired,
  resetErrorMessage: PropTypes.func.isRequired,
};

export {
  Error,
};

export default connect(mapStateToProps, { resetErrorMessage })(Error);
